import React from "react";
import "./index.css";

export default function Creatorbodyheading() {
  return (
    <div className="creator-body-heading">
      <h1>
        Are you a <span>creator?</span>
      </h1>
      <p>
        Hubhopper Studio is a podcast platform designed to make your podcasting
        process as simple as possible.
      </p>
    </div>
  );
}
